document.addEventListener('turbolinks:load', () => {
  const calendarContent = document.getElementById('calendar-content');
  if (!calendarContent) return;
  if (window.App.calendarSubscription) return;

  window.App.calendarSubscription = window.App.cable.subscriptions.create('CalendarChannel', {
    received(data) {
      if (data.event === 'refresh') {
        Turbolinks.visit(window.location.href, { action: 'replace' });
      }
    }
  });
});
